/// <amd-module name="Repos/Views/Settings/Repositories/Components/TextboxDialog" />
import React = require("react");
import * as Resources from "Repos/Views/Settings/Repositories/Resources";
import { IObservableValue, IReadonlyObservableValue, ObservableValue } from "VSS/Core/Observable";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Dialog } from "VSSUI/Dialog";
import { FormItem } from "VSSUI/FormItem";
import { Observer } from "VSSUI/Observer";
import { Spinner } from "VSSUI/Spinner";
import { TextField } from "VSSUI/TextField";

interface ITextboxDialogProps {
    errorMessage?: IReadonlyObservableValue<string>;
    isLoading?: IReadonlyObservableValue<boolean>;
    message?: string;
    onCancel: () => void;
    onClick: (event: React.MouseEvent<HTMLElement, MouseEvent> | React.KeyboardEvent<HTMLElement>, textboxValue: string) => void;
    primaryButtonDisabled?: (textboxValue: string) => boolean;
    primaryButtonDanger?: boolean;
    primaryButtonText: string;
    showError?: IReadonlyObservableValue<boolean>;
    textboxInitialValue?: string;
    textboxPlaceholder?: string;
    title: string;
}

export class TextboxDialog extends VssComponent<ITextboxDialogProps> {
    private textboxValue: IObservableValue<string>;

    public constructor(props: ITextboxDialogProps, context: IVssComponentContext) {
        super(props, context);
        this.textboxValue = new ObservableValue<string>(props.textboxInitialValue || "");
    }

    public render = (): JSX.Element => {
        return (
            <Observer loading={this.props.isLoading} text={this.textboxValue}>
                {(props: { loading: boolean | undefined; text: string }) => {
                    return (
                        <Dialog
                            defaultActiveElement=".bolt-textfield-input"
                            titleProps={{ text: this.props.title }}
                            footerButtonProps={[
                                {
                                    text: Resources.Cancel,
                                    onClick: this.props.onCancel
                                },
                                {
                                    danger: this.props.primaryButtonDanger,
                                    disabled: !this.props.primaryButtonDisabled || this.props.primaryButtonDisabled(props.text),
                                    onClick: this.onClick,
                                    primary: !this.props.primaryButtonDanger && true,
                                    text: this.props.primaryButtonText
                                }
                            ]}
                            onDismiss={this.props.onCancel}
                        >
                            {!props.loading ? (
                                <FormItem message={this.props.errorMessage} error={this.props.showError} label={this.props.message}>
                                    <TextField
                                        value={this.textboxValue}
                                        onChange={e => (this.textboxValue.value = e.target.value)}
                                        placeholder={this.props.textboxPlaceholder}
                                        ariaLabel={this.props.textboxPlaceholder}
                                    />
                                </FormItem>
                            ) : (
                                <Spinner />
                            )}
                        </Dialog>
                    );
                }}
            </Observer>
        );
    };

    private onClick = (event: React.MouseEvent<HTMLElement, MouseEvent> | React.KeyboardEvent<HTMLElement>) => {
        this.props.onClick(event, this.textboxValue.value);
    };
}
